import { adminHttpClient } from '../commons/adminHttpClient'
import { ExpenseStatus } from 'domain/expenses/expenseStatus'
import OrderedPageFilter from '../commons/orderedPageFilter'
import PagedList from '../commons/pagedList'

export type PagedReimbursementRequests = PagedList<ReimbursementRequest>

export const enum ReimbursementRequestType {
  Expense,
  Premium,
}

export type GetAllReimbursementRequest = OrderedPageFilter & {
  reimbursementType: ReimbursementRequestType
  planPeriodId: string
  fromDate?: string
  toDate?: string
  q: string
}

export type ReimbursementRequest = {
  firstName: string
  lastName: string
  expenseNumber: number
  expenseStatus: ExpenseStatus
  amount: number
  submissionDate: Date
}

const getAllCompanyReimbursementRequests = (request: GetAllReimbursementRequest): Promise<PagedReimbursementRequests> =>
  adminHttpClient.get('Expenses/AllCompanyRequests', request)

export default getAllCompanyReimbursementRequests
